import { useAtomValue, useSetAtom } from 'jotai';

import { FloatingDraggable } from '@/components/floating-draggable/floating-draggable';
import { openToItemAtom } from '@/features/developer-tools/state/dev-tools-panel.state';
import { uxdsVersionRollbackStorageAtom } from '@/state/uxds-version-rollback.state';
import { Button } from '@/ux-common/components/button/button';

const buildPreviewLabel = (processViewVersion?: number, facilityMapVersion?: number): string => {
  const labels: string[] = [];
  if (processViewVersion != null) {
    labels.push(`PV v${processViewVersion}`);
  }
  if (facilityMapVersion != null) {
    labels.push(`FM v${facilityMapVersion}`);
  }
  return `Previewing ${labels.join(', ')}`;
};

export const UxdsVersionRollbackButton = () => {
  const storage = useAtomValue(uxdsVersionRollbackStorageAtom);
  const openToItem = useSetAtom(openToItemAtom);

  if (storage?.processViewVersion == null && storage?.facilityMapVersion == null) {
    return null;
  }

  return (
    <FloatingDraggable
      storageKey="uxds-version-rollback-button-position"
      defaultPosition={{
        right: 90,
        bottom: 70,
      }}
    >
      <Button
        className="btn btn-default btn-sm shadow-lg hover:shadow-xl ring-2 ring-[#7B68EE] hover:ring-[#7B68EE]/20 transition-all duration-200 hover:scale-105"
        style={{ backgroundColor: '#7B68EE' }}
        onClick={() => {
          openToItem('uxds-version-rollback');
        }}
        aria-label="Open UXDS version rollback"
        data-component="UxdsVersionRollbackButton"
        data-testid="uxds-version-rollback-button"
      >
        <span className="text-white font-semibold text-xs whitespace-nowrap">
          {buildPreviewLabel(storage.processViewVersion, storage.facilityMapVersion)}
        </span>
      </Button>
    </FloatingDraggable>
  );
};
